import { IconButton } from "@material-ui/core";
import React from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CreateDeploymentDialog from "./CreateDeploymentDialog";
import { UpdateDeploymentProps } from "./DeploymentDetails";
import { useAuthorization } from "../../authorizer/components/AuthorizationProvider";
import { getResolvedEnv } from "./EnvBadge";

const baseRegions = [
  { key: "Australia", value: "au" },
  { key: "South-east Asia (Singapore)", value: "ap" },
  { key: "UK South", value: "uk" },
  { key: "Global", value: "global" },
  { key: "EU-West", value: "eu-west" },
];

/** Options for the disabled region select on edit. Legacy codes use static labels; API target regions (e.g. us-east-1) must still yield one matching MenuItem or MUI Select renders empty. */
function getDeployedRegion(location: string): { key: string; value: string }[] {
  const fromBase = baseRegions.filter((region) => region.value === location);
  if (fromBase.length > 0) {
    return fromBase;
  }
  if (location) {
    return [{ key: getResolvedEnv(location), value: location }];
  }
  return [];
}

export interface DeploymentEditorLegacyProps {
  basePath?: string;
  resourceAppId?: string;
  version?: string;
  updateDeployment?: UpdateDeploymentProps;
}

/** As on `develop`: modal edit dialog + static region list for disabled select */
export const DeploymentEditorLegacy: React.FC<DeploymentEditorLegacyProps> = ({
  basePath = "",
  resourceAppId = "",
  version = "",
  updateDeployment,
}) => {
  const [editDeployment, setEditDeployment] = React.useState<boolean>(false);
  const { isActionAllowed } = useAuthorization(
    "SERVICE",
    updateDeployment?.serviceId ? updateDeployment?.serviceId : ""
  );
  const canUpdate = isActionAllowed("update");

  return (
    <>
      <IconButton
        onClick={() => setEditDeployment(true)}
        disabled={
          updateDeployment?.deploymentStatus !== "DEPLOY_COMPLETED" || !canUpdate
        }
      >
        <EditOutlinedIcon />
      </IconButton>
      {editDeployment && (
        <CreateDeploymentDialog
          open={editDeployment}
          onClose={() => setEditDeployment(false)}
          onSuccess={() => {
            setEditDeployment(false);
            updateDeployment?.refreshDeployments?.();
          }}
          basePath={basePath}
          resourceAppId={resourceAppId}
          version={version}
          availableRegions={getDeployedRegion(updateDeployment?.region || "")}
          updateDeployment={updateDeployment}
        />
      )}
    </>
  );
};
